var scripts = document.getElementsByTagName("script");

for (var i = 0; i < scripts.length; i++){
  var src = scripts[i].getAttribute("src");
  if (/jaguar\.all/.test(src)) {
    __webpack_public_path__ = src.substr(0, src.lastIndexOf("/") + 1);
    window.PUBLIC_PATH = __webpack_public_path__;
    break;
  }
}

window.jQuery = window.$ = require('./js/jquery/jquery-2.0.3.js');

require('bootstrap/dist/js/bootstrap.js');

window.moment = require('./../../node_modules/moment/moment.js');
require('./../../node_modules/moment/locale/pt-br.js');

require('./js/jquery/jquery-migrate-1.2.1.min.js');
require('./js/jquery/jquery.select-filter.js');
require('./js/jquery/jquery.simplemodal-1.4.4.js');
require('./js/jquery/jquery.reject.js');
require('./js/jquery/jquery.maskMoney.js');
require('./js/jquery/jquery.maskedinput-1.3.js');
require('./js/jquery/jquery.idletimer.js');
require('./js/jquery/jquery.idletimeout.js');
require('./js/jquery/jqueryUI/js/jquery-ui-1.10.3.min.js');
require('./js/jquery/jqueryUI/js/jquery-ui-numeric.js');
require('./js/jquery/jquery_alert/jquery.alerts.js');
require('./js/jquery/jquery.tablesorter.min.js');
require('./js/jquery/jquery_file_upload/jquery.form.js');
require('./js/jquery/jquery_file_upload/jquery.uploadfile.js');

require('./js/jquery/sweetalert2.css');
window.swal = require('./js/jquery/sweetalert2.js');

require('./js/jquery/datatables.css');
window.$.DataTable = require('./js/jquery/datatables.js');

require('./js/jquery/jqueryUI/redmond/jquery-ui-1.10.3.css');
require('./js/jquery/jquery_alert/jquery.alerts.css');

var fsmenu = require('exports-loader?FSMenu,addEvent,repositionMenus,activePageHighlight,getRef,getSty!./js/fsmenu/fsmenu');

Object.keys(fsmenu).map(function(i) {
  window[i] = fsmenu[i];
});

window.$.extend(window.$.fn.dataTableExt.oSort, {
  "datetime-pre": function (date) {
    date = date.replace(" ", "");

    if (!date)
      return 0;

    var arrDate = date.split(/[\.\-\/\:\ ]/);
    var year    = arrDate[2] ? arrDate[2] : 0;
    var month   = (arrDate[1].length === 1) ? (0 + arrDate[1]) : arrDate[1];
    var day     = (arrDate[0].length === 1) ? (0 + arrDate[0]) : arrDate[0];
    var hour    = arrDate[3] ? arrDate[3] : 0;
    var minutes = arrDate[4] ? arrDate[4] : 0;
    var seconds = arrDate[5] ? arrDate[5] : 0;

    return (year + month + day + hour + minutes + seconds) * 1;
  },

  "datetime-asc": function (a, b) {
    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
  },

  "datetime-desc": function (a, b) {
    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
  }
});

window.$.extend(true, window.$.fn.dataTable.defaults, {
  "language": {
    "sEmptyTable": "Nenhum registro encontrado",
    "sInfo": "Mostrando _START_ à _END_ de _TOTAL_ registros",
    "sInfoEmpty": "Mostrando 0 de 0 registros",
    "sInfoFiltered": "(Filtrados de _MAX_ registros)",
    "sInfoPostFix": "",
    "sInfoThousands": ".",
    "sLengthMenu": "_MENU_ &nbsp;resultados por página",
    "sLoadingRecords": "Carregando...",
    "sProcessing": "Processando...",
    "sZeroRecords": "Nenhum registro encontrado",
    "sSearch": "Pesquisar",
    "oPaginate": {
      "sNext": "Próximo",
      "sPrevious": "Anterior",
      "sFirst": "Primeiro",
      "sLast": "Último"
    },
    "oAria": {
      "sSortAscending": ": Ordenar colunas de forma ascendente",
      "sSortDescending": ": Ordenar colunas de forma descendente"
    },
    "select": {
      "rows": {
        "_": "Selecionado %d linhas",
        "0": "Nenhuma linha selecionada",
        "1": "Selecionado 1 linha"
      }
    },
    "buttons": {
      "copy": "Copiar para a área de transferência",
      "copyTitle": "Cópia bem sucedida",
      "copySuccess": {
        "1": "Uma linha copiada com sucesso",
        "_": "%d linhas copiadas com sucesso"
      }
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./jaguar/js.js
// module id = 1
// module chunks = 0 1